import { connect } from 'react-redux';
import { reduxForm, SubmissionError } from 'redux-form';

import { getValidationRules } from '../validation/validation';
import UpdateEmailComponent from '../components/profile/Profile/UpdateEmailComponent';
import { setLoading, updateEmailAction } from '../store/actions/session';
import { getLoadingStatus } from './selectors/licenseSelectors';
import { isUserAdmin, getCurrentUser } from './selectors/userSelectors';
import SIGN_IN_RULES from '../validation/validationRules/signIn';

const UPDATE_EMAIL_FORM = 'update-email';

const mapStateToProps = (state) => ({
    isLoading: getLoadingStatus(state),
    canEdit: isUserAdmin(state),
    currentUserInfo: getCurrentUser(state),
});

const mapDispatchToProps = {
    setLoading,
    updateEmailAction,
}

const mergeProps = (
    { history, ...stateProps, currentUserInfo },
    { updateEmailAction, setLoading },
) => {
    return {
        setLoading,
        ...stateProps,
        initialValues: currentUserInfo,
        onSubmit: ({ email, password, firstName, lastName, developerId, uid }) => {
            const prevEmail = currentUserInfo.email;
            const action = updateEmailAction;
            const userId = uid;
            if (email.toLowerCase() !== prevEmail.toLowerCase()) {
                return action({ userId, prevEmail, email, password, firstName, lastName, developerId });
            } else {
                throw new SubmissionError({
                    email: 'Please enter a different email address.',
                });
            }
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: UPDATE_EMAIL_FORM,
    validate: getValidationRules([
        'email',
        'password',
    ], SIGN_IN_RULES),
})(UpdateEmailComponent));



// WEBPACK FOOTER //
// ./src/containers/UpdateEmailContainer.js